module.exports = __webpack_public_path__ + "img/csv.5795b96c.svg";